module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "chapter-3"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "chapter-3-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-3-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("B")]), _vm._v("lue and white tape blocked off the entrance to the path leading down to the Thames. A bored-looking constable was guarding the entry to the outer cordon. He heard a car coming up the road and watched as an old 2003 grey Porsche 911 two-door coupe came to a halt a few yards away. A tall slim man wearing a blue-grey suit and white open-necked shirt got out of the car and walked towards him.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Bloody press")]), _vm._v(", the constable thought. He noted the groomed short dark hair, greying at the edges, the chiselled jawline and hint of a stubble. He half expected the man to pull out a press card as he approached. The constable held up a hand. ‘Sorry, sir. This is a crime scene, I’m afraid you can’t park there. And I can’t talk to the press.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The man smiled. ‘No problem, I’m not press,’ he said, fishing into his jacket pocket to hold up a warrant card for the constable to see. ‘DCI Fleming. I’m the on-call SIO.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Colour rose in the constable’s cheeks as he shifted his gaze away from the tired red eyes that under normal circumstances would have matched the colour of Fleming’s suit. ‘Oh… sorry, sir. The car… I thought…’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Got the call at home so came straight here.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Ah, right, well, the boat’s down there, sir.’ The constable pointed down the path.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Thanks.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The constable watched as Fleming returned to the Porsche, opened the boot and kitted himself out with latex gloves, paper shoes and overalls. He nodded at the constable as he ducked under the tape to head off down the path. ‘Keep an eye on the car, eh?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The constable grunted and waited until Fleming was out of earshot. He shook his head. ‘Flashy Scots git.’")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9dd15b90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter003.vue
// module id = 81
// module chunks = 0